import React from 'react'
import { DiffResult } from '../helpers';
import Modal from '../../Modal/Modal';

interface Props {
  dataDifferences: { channelId: string; diffs: DiffResult[] } | null;
  isOpenModal: boolean;
  closeModal: () => void;
}

const ChannelSettingsDiff: React.FC<Props> = ({ dataDifferences, isOpenModal, closeModal }) => {
  return (
    <Modal
      isVisible={isOpenModal}
      modalTitle={`Channel ${dataDifferences?.channelId} Settings Differences`}
      showAcceptBtn={false}
      showCancelBtn={false}
      cancelBtnText="Close"
      onClose={closeModal}
      className="min-w-fit"
    >
      <table className="w-full table-auto border-collapse border border-gray-300">
        <thead>
          <tr>
            <th className="border border-gray-300 px-4 py-2">Setting</th>
            <th className="border border-gray-300 px-4 py-2">Database Value</th>
            <th className="border border-gray-300 px-4 py-2">Channel Value</th>
          </tr>
        </thead>
        <tbody>
          {dataDifferences && dataDifferences.diffs.map((diff) => (
            <tr key={diff.nameProperty}>
              <td className="border border-gray-300 px-4 py-2 font-medium text-left">
                {diff.nameProperty}
              </td>
              <td className="border border-gray-300 px-4 py-2">
                {String(diff.differences.db)}
              </td>
              <td className="border border-gray-300 px-4 py-2">
                {String(diff.differences.channel)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Modal>
  )
};

export default ChannelSettingsDiff;
